/**
 * Quick Buy Image Click Handlers
 * Handles thumbnail clicks to show enlarged product images
 */
(function() {
  let backdropInitialized = false;
  let escInitialized = false;
  
  function initImageClickHandlers() {
    const backdrop = document.querySelector('.qb-image-backdrop');
    const containers = document.querySelectorAll('.qb-image-hover-container:not([data-click-initialized])');
    
    containers.forEach(container => {
      const thumb = container.querySelector('.qb-product-thumb');
      const overlay = container.querySelector('.qb-hover-image-overlay');
      const closeBtn = container.querySelector('.qb-image-close-btn');
      
      if (!thumb || !overlay) {
        return;
      }
      
      // Mark as initialized to prevent duplicate listeners
      container.setAttribute('data-click-initialized', 'true');
      
      // Click on thumbnail to show image
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Close any other open images
        document.querySelectorAll('.qb-image-hover-container.active').forEach(el => {
          if (el !== container) el.classList.remove('active');
        });
        
        // Toggle current image
        const isActive = container.classList.toggle('active');
        
        if (backdrop) {
          backdrop.classList.toggle('active', isActive);
        }
        
        // Prevent body scroll when image is open
        if (isActive) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
      
      // Click close button
      if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          container.classList.remove('active');
          if (backdrop) backdrop.classList.remove('active');
          document.body.style.overflow = '';
        });
      }
    });
    
    // Click backdrop to close (initialize only once)
    if (backdrop && !backdropInitialized) {
      backdropInitialized = true;
      backdrop.addEventListener('click', () => {
        document.querySelectorAll('.qb-image-hover-container.active').forEach(el => {
          el.classList.remove('active');
        });
        backdrop.classList.remove('active');
        document.body.style.overflow = '';
      });
    }
    
    // ESC key to close (initialize only once)
    if (!escInitialized) {
      escInitialized = true;
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          document.querySelectorAll('.qb-image-hover-container.active').forEach(el => {
            el.classList.remove('active');
          });
          const backdrop = document.querySelector('.qb-image-backdrop');
          if (backdrop) backdrop.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    }
  }
  
  // Make function globally accessible so it can be called after dynamic content loads
  window.initImageClickHandlers = initImageClickHandlers;
  
  // Initialize handlers when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageClickHandlers);
  } else {
    initImageClickHandlers();
  }
  
  // Re-initialize after dynamic content loads (for pagination/filtering)
  const observer = new MutationObserver((mutations) => {
    // Only trigger on childList changes (new products added), not subtree modifications
    const hasChildListChanges = mutations.some(m => m.type === 'childList' && m.addedNodes.length > 0);
    if (!hasChildListChanges) return;
    
    initImageClickHandlers();
  });
  
  // Watch the search results container for changes
  const targetNode = document.getElementById('QuickBuySearchList');
  if (targetNode) {
    // Only watch for direct child changes, not all subtree modifications
    observer.observe(targetNode, { childList: true, subtree: false });
  }
})();

